import { render, staticRenderFns } from "./mdownload.vue?vue&type=template&id=29c99b5a&scoped=true&"
import script from "./mdownload.vue?vue&type=script&lang=js&"
export * from "./mdownload.vue?vue&type=script&lang=js&"
import style0 from "./mdownload.vue?vue&type=style&index=0&id=29c99b5a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c99b5a",
  null
  
)

export default component.exports